var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgComment = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 7.33325C1.33398 6.40425 1.33398 5.93974 1.39554 5.55108C1.7344 3.41162 3.41235 1.73367 5.55181 1.39481C5.94048 1.33325 6.40498 1.33325 7.33399 1.33325H8.00065C9.5506 1.33325 10.3256 1.33325 10.9614 1.50362C12.6869 1.96596 14.0346 3.3137 14.4969 5.03916C14.6673 5.67499 14.6673 6.44997 14.6673 7.99992V12.7804C14.6673 13.9039 13.4417 14.5979 12.4783 14.0198V14.0198C11.7295 13.5706 10.8727 13.3333 9.9995 13.3333H7.33398C6.40498 13.3333 5.94048 13.3333 5.55181 13.2717C3.41235 12.9328 1.7344 11.2549 1.39554 9.11542C1.33398 8.72676 1.33398 8.26226 1.33398 7.33325V7.33325Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComment);
export default ForwardRef;